import React from 'react';

const Loading = () => {
  return (
    <div className="ntr-loading-nutror">
      <div className="ntr-loading">
        <div className="ntr-large"></div>
        <div className="ntr-logo">
          <svg viewBox="0 0 128.94 128.93" xmlns="http://www.w3.org/2000/svg">
            <g fill="#27921a" fillRule="nonzero">
              <path d="M23.33 78c.93-2.79 1.77-5.74 2.62-8.74 2.05-7.26 4.2-14.8 7.88-21.08s9-8.74 14.49-7c7 2.26 9.25 10.37 10.92 16.28l.2.73c.87 3.08 1.67 6.18 2.46 9.28.88 3.41 1.76 6.83 2.73 10.22.16.57.33 1.22.5 1.93.63 2.51 1.57 6.31 3.19 7.16a1.94 1.94 0 0 0 1.7 0C75.57 84.67 80.56 69.49 82.69 63l.65-2c2.1-6.2 4-12.6 5.75-18.79 3-10.49 6.22-21.3 10.7-31.63a64.38 64.38 0 0 0-85.45 94.28z" />
              <path d="M126.82 48.1A64.24 64.24 0 0 0 112 20.93a259.62 259.62 0 0 0-8.33 25.79A255.55 255.55 0 0 1 95 73.57c-3.61 8.91-13.24 32.52-28.67 30.19-13.39-2-17.2-20.6-20-34.14-.59-2.88-1.12-5.47-1.68-7.59-.27.85-.53 1.7-.79 2.55s-.58 1.93-.9 2.87l-16.39 49.13A64.45 64.45 0 0 0 126.82 48.1z" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  )
}

export default Loading;